module.exports = __webpack_public_path__ + "img/team-10.69d632f9.jpg";